// extracted by mini-css-extract-plugin
export default {"providersWrapper":"ProvidersFilter_providersWrapper--W9V"};